export default {
  type: 'Type',
  relevanceNo: 'Numéro de commande associé',
  consultContent: 'Contenu de la consultation',
  submitTime: 'Heure de soumission',
  consultTypeEnum: {
    0: 'Demande de commande',
    1: 'Consultation de colis',
  },
  consultStatusEnum: {
    0: 'non traité',
    1: 'en cours de traitement',
    2: 'terminé',
  },
}
